/* -----------------UI--------------- */
import { Dialog } from "@mui/material";

/* -----------------Child components--------------- */
import { DATE_FORMAT } from "@memorang/constants/src/date";
import { LocalizationProvider, StaticDatePicker } from "@mui/x-date-pickers";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";
import { IconButton } from "react-native-paper";

type Props = {
	isVisible: boolean;
	onCancel: () => void;
	onConfirm: (date: Date) => void;
	initialDate?: string;
	okButtonLabel?: string;
	toolbarTitle?: string;
};
const DateTimePicker = ({
	isVisible,
	onCancel,
	onConfirm,
	initialDate,
	okButtonLabel,
	toolbarTitle,
}: Props) => {
	const { t } = useTranslation();

	const today = DateTime.now().startOf("day");

	let initialSelectedDate: DateTime | undefined;
	if (initialDate) {
		const parsed = DateTime.fromFormat(initialDate, DATE_FORMAT).startOf("day");
		if (parsed.isValid && parsed >= today) {
			initialSelectedDate = parsed;
		}
	}

	return (
		<Dialog
			open={isVisible}
			onClose={onCancel}
			maxWidth="xs"
			sx={{
				"& .MuiDialog-paper": {
					maxWidth: 334,
				},
			}}
		>
			<IconButton
				icon={"close"}
				onPress={onCancel}
				style={{
					position: "absolute",
					right: 8,
					top: 6,
					zIndex: 1000,
				}}
			/>
			<LocalizationProvider dateAdapter={AdapterLuxon}>
				<StaticDatePicker
					displayStaticWrapperAs="mobile"
					defaultValue={initialSelectedDate}
					referenceDate={today}
					minDate={today}
					disablePast
					slotProps={{
						actionBar: {
							actions: ["accept"],
						},
					}}
					localeText={{
						okButtonLabel: okButtonLabel ?? t("commandBar.actions.setExamDate"),
						toolbarTitle: toolbarTitle ?? t("common.selectTestDate"),
					}}
					onAccept={(date) => {
						if (date) {
							onConfirm(date.toJSDate());
						}
					}}
					onClose={onCancel}
				/>
			</LocalizationProvider>
		</Dialog>
	);
};

export default DateTimePicker;
